/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { DocsUrls } from '@fai/constants/shared-urls';

function DocumentButton() {
  const { t } = useTranslation();

  return (
    <Button variant="outline" size="sm" onClick={() => window.open(DocsUrls.Default)}>
      {t('layout.docs')}
    </Button>
  );
}

export default DocumentButton;
